import { Dates_, device, Dropdown_, Grey_, Grey_Link, PageAlwaysVisible, PageFull, PageTitle, Slider_ } from 'monica-alexandria'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import Statistics_Summary from '../../partials/statistics/Statistics_Summary'
import Statistics_Grouping_Toggle from '../../partials/statistics/Statistics_Grouping_Toggle'
import { getBreakdownView, getRetentionViewAdvanced, getStatisticsSummary } from '../../../services/api/Statistics'
import { useTranslation } from 'react-i18next'
// import Statistics_Retention from './partials/Statistics_Retention'
import { WidgetBox } from '../../../styles/Layout.css'
import Statistics_Breakdown from '../../partials/statistics/Statistics_Breakdown'
import { scaleLinear } from 'd3-scale'
import Widget_Chart from '../../partials/widgetChart/Widget_Chart'
import { format } from 'date-fns';
import Statistics_Retention from '../../partials/statistics/Statistics_Retention'

const StatsSumWrapper = styled.div`
  margin-bottom: 2rem;
`

const WidgetGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 1rem;
  padding-top: 2rem;
  
  @media ${device.md}{
    
    grid-template-columns: 1fr;
  }
`

const WidgetInnerGrid = styled.div`
  display: grid;
  grid-template-rows: 1fr 2fr;

  gap: 1rem;
  
  @media ${device.md}{
    
    grid-template-columns: 1fr;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
`;


const WidgetCell = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;

`;

const CellContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: bold;
  text-align: center;
  line-height: 1.4;


  .details p {
    font-size: 1.2rem;
    opacity: 0.9;
  }

  p{
    color: var(--white);
  }

  ${props => props.value < 10 ? `color: #333;` : `color: #fff;`}
`;
const WidgetContent = styled.div`
  padding-top: 1rem;

`

const WidgetTitle = styled.h4`
  padding-bottom: 2rem;
`;

const WidgetMetric = styled.h1``;

const WidgetSubtitle = styled.p`
  padding-bottom: 2rem;
`;

const WidgetChartWrapper = styled.div`
  padding-bottom: 4rem;
`
const PageTitleInner = styled.div`
  display: flex;
  align-items: center;
  gap:1rem;
`

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  margin-left: auto;
`;

const FilterLabel = styled.label`
  font-size: 0.9rem;
  color: ${p => p.theme.dark};
  font-weight: 500;
  margin-bottom: 0.25rem;
`;

const SelectedDatesDisplay = styled.div`
  font-size: 0.85rem;
  color: ${p => p.theme.grey};
  font-style: italic;
`;


const DateInput = styled.input`
  padding: 0.6rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid ${p => p.theme.border || '#ccc'};
  font-size: 0.9rem;
  width: 220px;
  cursor: pointer;
`;

const DatePickerWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownPosition = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  /* background: white;
  border: 1px solid ${p => p.theme.border || '#ccc'};
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-top: 0.5rem; */
`;


export default function DAILYPROFIT_STATISTICS() {
    const navigate = useNavigate()
    const [statisticsSum, setStatisticsSum] = useState([])
    const [groupBy, setGroupBy] = useState('subscription')
    const {t} = useTranslation();
    const {lang} = useParams();
    const themeProp = useTheme();
    
    const [average, setAverage] = useState(0);
    const [dateFilters, setDateFilters] = useState({startDate:'', endDate:''})

    const [showDatePicker, setShowDatePicker] = useState(false);
    const [renderedLabel, setRenderedLabel] = useState('');

    const [structuredData, setStructuredData] = useState([]);
    const [xLabels, setXLabels] = useState([]);
    const [rawData, setRawData] = useState({});
    const [kpiData, setKpiData] = useState({});
    
    const flatValues = structuredData.flat().map(cell => cell.sum || 0);
    const maxValue = Math.max(...flatValues, 1); // prevent division by zero

    const mainLight = getComputedStyle(document.documentElement).getPropertyValue('--mainLight').trim() || '#d6e685';
    const mainDark = getComputedStyle(document.documentElement).getPropertyValue('--mainDark').trim() || '#1e6823';
  
    const keys = Object.keys(kpiData || {});
    const lastKey = keys[keys?.length - 1];
    const lastValue = lastKey ? kpiData[lastKey] : null;
    const colorScale = scaleLinear().domain([0, maxValue]).range([mainLight, mainDark]);
    
    const months = Object.keys(kpiData || {});


    const get_statistics_dailyprofit_summary = (start, end) =>{
        getStatisticsSummary(['dailyprofit'], start, end, groupBy).then(res => {
            setStatisticsSum(res?.data?.data)

            console.log('getStatisticsSummary', res?.data?.data);
            
        });


    }
    const get_breakdown_view = (start, end) =>{
        getBreakdownView(['dailyprofit'], start, end, groupBy).then(res => {
          console.log('tsifsa!!!', res?.data?.data);
          setKpiData(res?.data?.data?.breakdown)
        });
      }
  
    const keysStats = [
        {value: "activeTotal", text:'Total active'},
        {value: "newPaid", text: "New paid"},
        {value:"returning", text: "Returning"},
        {value: "lost", text: "Lost"},
        {value: "meta", text: "Meta"},
        {value: "google", text: "Google"},
        {value: "activeQuests", text: "Active quests"},
        {value: "newActiveQuests", text: "New quests"}
      ];
    

    const transformData = (raw, key = 'sum') => {
        const yLabels = Object.keys(raw);
        const xLabelSet = new Set();

        yLabels.forEach(label => {
        Object.keys(raw[label]).forEach(month => xLabelSet.add(month));
        });

        const xLabels = Array.from(xLabelSet).sort();
        const structuredData = yLabels.map(label =>
        xLabels.map(month => raw[label][month] || { sum: 0, loyal: 0, returning: 0 })
        );


        
    return { xLabels, data: structuredData };
    };

  

    const onChangeDates = (selections) => {
      const [start, end] = selections;
    
      if (!start || !end) return;
    
      // Format for display
      const label = `${format(new Date(start), 'MMM yyyy')} → ${format(new Date(end), 'MMM yyyy')}`;
      setRenderedLabel(label);
    
      // Format for API (YYYY-MM-DD)
      const formattedStart = format(new Date(start), 'yyyy-MM-dd');
      const formattedEnd = format(new Date(end), 'yyyy-MM-dd');
    
      // Save to state
      setDateFilters({
        startDate: formattedStart,
        endDate: formattedEnd,
        renderedDates: selections,
      });
    
      // Call the API with formatted dates
      get_statistics_dailyprofit_summary(formattedStart+'T00:00:00.000Z', formattedEnd+'T00:00:00.000Z');
      get_breakdown_view(formattedStart+'T00:00:00.000Z', formattedEnd+'T00:00:00.000Z');
      setShowDatePicker(false);
    };
    const toggleDatePicker = () => {
      setShowDatePicker(prev => !prev);
    };


    useEffect(() => {
        getRetentionViewAdvanced(['dailyprofit'], groupBy)
          .then(res => {
            setRawData(res.data.data);
            const transformed = transformData(res.data.data, 'sum');
            setXLabels(transformed.xLabels);
            setStructuredData(transformed.data);

            const data = Object.values(res?.data?.data)?.flatMap(months =>
                Object.values(months).map(val => val?.sum || 0)
              );
              const avg = data.reduce((a, b) => a + b, 0) / data.length;
              setAverage(Math.round(avg));
          })
          .catch(err => console.log(err));
      }, [groupBy]);
  

    useEffect(() => {
        get_statistics_dailyprofit_summary();
        get_breakdown_view();
    }, [groupBy]);

  return (
    <PageFull>
      {showDatePicker? 
        <Slider_
          title={t("Dates")} 
          text={t("Add")}
          onClose = {()=> setShowDatePicker(false)}
          // onClick = {() =>  createFakeInvoice()}
          grey={t("Cancel")}
          iconGreyLeft="Xicon"
          onGrey= {() => setShowDatePicker(false)}
        >
          <Dates_
              allowPartialRange={true}
              onChange={onChangeDates}
              value={dateFilters?.renderedDates}
              selectRange={true}
              dateFullCellRender={(date) => date?.date()}
              maxDate={new Date()}
              minDetail="year"
              maxDetail="year"
              view="year"
            />
        </Slider_>
      :null}
        <PageAlwaysVisible>
          <PageTitle>
            <PageTitleInner>
              <Grey_Link noPadding iconLeft="Back" onClick={() => navigate(`/${lang}/akihiko/griphook/statistics`)} />
              <h1>{t('Questad')}</h1>
            </PageTitleInner>
            <Statistics_Grouping_Toggle groupBy={groupBy} onChange={setGroupBy} />

            <FiltersWrapper>
              <Grey_ iconLeft='Calendar' text= {renderedLabel || t("Select months")}  onClick={toggleDatePicker}/>
            </FiltersWrapper>

          </PageTitle>
            {/* <StatsSumWrapper>
                <Statistics_Summary statistics={statisticsSum} />
            </StatsSumWrapper> */}
            <WidgetGrid>
                <WidgetBox>
                    <WidgetTitle>{t('Retention')}</WidgetTitle>
                    {/* <WidgetMetric>{average}</WidgetMetric>
                    <WidgetSubtitle>{t('Avg. Retention')}</WidgetSubtitle> */}
                    <Statistics_Retention structuredData={structuredData} xLabels={xLabels} />
                </WidgetBox>
                    {/* <WidgetBox >
        
                    <WidgetTitle>{'Retention'}</WidgetTitle>
                    <WidgetMetric>{average}</WidgetMetric>
                    <p>{t('Avg. Retention')}</p>
                
                    <WidgetContent>
                    {structuredData?.map((row, i) => (
                        <Row key={i}>
                            {row.map((cellData, j) => {
                            const sum = cellData.sum || 0;
                            const backgroundColor = sum === 0 ? themeProp.mid : colorScale(sum);
                            
                            return (
                                <WidgetCell key={j} style={{ backgroundColor }}  title={`Total: ${sum}\nLoyal: ${cellData.loyal}\nReturning: ${cellData.returning}\nRetention: ${''}%`}>
                                {sum > 0 && <CellContent value={sum}/>}
                                </WidgetCell>
                            );
                            })}
                        </Row>
                        ))}
                    </WidgetContent>
                </WidgetBox> */}
                <WidgetInnerGrid>
                  <WidgetBox >
                    <WidgetTitle>{t('Total active')}</WidgetTitle>

                    <WidgetChartWrapper>
                        <Widget_Chart kpiData={kpiData  || []} />
                    </WidgetChartWrapper>
                </WidgetBox> 
                <WidgetBox>
                    <Statistics_Breakdown
                      keysStats={keysStats} 
                      months={months} 
                      kpiData={kpiData} 
                    /> 
                </WidgetBox >

                </WidgetInnerGrid>
            </WidgetGrid>
           
        </PageAlwaysVisible>
    </PageFull>
  )
}
